// extracted by mini-css-extract-plugin
export default {"cardHeader":"c-e_cy"};